// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"210":"011b3958","485":"ef274464","507":"b4fdcb0d","715":"c4f4b7ae"}[chunkId] + ".css";
};